import React, {} from 'react'
import {Redirect} from 'react-router-dom'

const Officer = () => <Redirect to={'/officer/usestatus'}/>;

export default Officer;
